var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Special Management/Transparent - WithoutCircle",
    clipPath: "url(#clip0_577_171098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Special"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M150.669 141.687C137.875 153.421 118.125 153.421 105.331 141.687L100.517 117.595L112.788 121.683C114.93 122.394 117.276 121.588 118.532 119.715L128 105.505L137.468 119.715C138.717 121.588 141.07 122.394 143.212 121.683L155.483 117.595L150.669 141.687Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M128 182C157.823 182 182 157.823 182 128C182 98.1766 157.823 74 128 74C98.1766 74 74 98.1766 74 128C74 157.823 98.1766 182 128 182Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_171098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecial);
export default __webpack_public_path__ + "static/media/Special.0b342cdbc57690f1e5dc64733454fed7.svg";
export { ForwardRef as ReactComponent };